	function chikungunya(){
	return {
		"games":[
			{
				"informs":[
					{
						"text":"Os principais sintomas da chikungunya são: febre; dores intensas nas juntas, em geral bilaterais (joelho esquerdo e direito, pulso direito e esquerdo, etc); pele e olhos avermelhados; dores pelo corpo; dor de cabeça; náuseas e vômitos.",
						"title":"Sintomas",
						"image":"images/games/informs/chikungunya/sintomas/1.jpg",
					},
					{
						"text":"Cerca de 30% dos casos não chegam a desenvolver sintomas. Normalmente, os sintomas aparecem de dois a 12 dias após a picada do mosquito, período conhecido como incubação.",
						"title":"Sintomas",
						"image":"images/games/informs/chikungunya/sintomas/2.jpg",
					}
				],
				"pathImageGame":"midias/images/games/puzzles/chikungunya/sintomas/1.jpg"
			},
			{
				"informs":[
					{
						"text":"O tratamento da chikungunya é feito de acordo com os sintomas, com o uso de analgésicos, antitérmicos e anti-inflamatórios para aliviar febre e dores.",
						"title":"Tratamento",
						"image":"images/games/informs/chikungunya/tratamento/1.jpg",
					},
					{
						"text":"Para evitar complicações da chikungunya, é importante não utilizar na fase aguda anti-inflamatórios que possam interferir na coagulação do sangue, pelo risco de ocorrer hemorragia e insuficiência renal.",
						"title":"Tratamento",
						"image":"images/games/informs/chikungunya/tratamento/2.jpg",
					},
					{
						"text":"Por isso é sempre RECOMENDÁVEL o acompanhamento médico e não se deve praticar a automedicação, particularmente nunca tomar ácido acetilsalicílico, que é muito popular contra dor e febre, mas tem ação como anticoagulante e pode provocar hemorragia.",
						"title":"Tratamento",
						"image":"images/games/informs/chikungunya/tratamento/3.jpg",
					},
					{
						"text":"A doença pode deixar sequelas graves, particularmente nas articulações, e sob avaliação médica conforme cada caso, pode ser recomendada a fisioterapia.",
						"title":"Tratamento",
						"image":"images/games/informs/chikungunya/tratamento/4.jpg",
					}
				],
				"pathImageGame":"midias/images/games/puzzles/chikungunya/tratamento/2.jpg"
			},
			{
				"informs":[
					{
						"text":"A transmissão da mulher grávida para o feto só acontece quando a mãe fica doente nos últimos 7 dias (última semana) de gravidez.",
						"title":"Curiosidades",
						"image":"images/games/informs/chikungunya/curiosidades/1.jpg",
					},
					{
						"text":"Neste caso, a criança, mesmo que nasça saudável, deve permanecer internada por uma semana para observação e para o tratamento imediato se desenvolver a doença.",
						"title":"Curiosidades",
						"image":"images/games/informs/chikungunya/curiosidades/2.jpg",
					}
				],
				"pathImageGame":"midias/images/games/puzzles/chikungunya/curiosidades/1.jpg"
			}
		]
	};
}

export {chikungunya};
